import { createClient } from '@/shared/api';
import type { SaveSignatureMutation, SaveSignatureMutationVariables } from '@/shared/api';
import SAVE_SIGNATURE_MUTATION from '../mutations/saveSignature';

/**
 * Stores the signature a physician drew on their profile. Runs SAVE_SIGNATURE_MUTATION with the url as the signature variable, throws the returned message on failure and hands back the raw mutation result.
 *
 * @param signatureUrl - Uploaded signature image url.
 * @returns The raw Apollo mutation result.
 */
const handleSaveSignature = async (signatureUrl: string) => {
  const client = createClient();
  const saveSignatureResult = await client.mutate<
    SaveSignatureMutation,
    SaveSignatureMutationVariables
  >({
    mutation: SAVE_SIGNATURE_MUTATION,
    variables: {
      signature: signatureUrl,
    },
  });
  if (!saveSignatureResult?.data?.saveSignature?.isSuccess) {
    throw new Error(saveSignatureResult?.data?.saveSignature?.message ?? undefined);
  }
  return saveSignatureResult;
};

export default handleSaveSignature;
